import React, { useEffect, useState } from "react";
import Input from "../../Components/Input/Input";
import AuthButton from "../../Components/AuthButton/AuthButton";
import { useDispatch, useSelector } from "react-redux";
import { UploadImage, addConvertAccount } from "../../Actions/actions";
import moment from "moment";
import SignatureUpload from "../SignatureUpload/signatureUpload";
import DropDownCustom from "../DropDownCustom/DropDownCustom";

const CreateAccountModal = ({ id, lead, isOpen, onClose, onHit }) => {
  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = moment(date);
    if (!parsedDate.isValid()) return "";
    return parsedDate.format("DD-MMM-yy HH:mm:ss");
  };
  const dispatch = useDispatch();
  const { loginData, employeesData } = useSelector(
    (state) => state.userReducer
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const [formData, setFormData] = useState({
    leadId: "",
    salesExecutiveName: "",
    salesManagerSignature: "",
    salesManagerRemarks: "",
    salesManagerSignatureDate: "",
    regionalManagerSignature: "",
    regionalManagerRemarks: "",
    regionalManagerSignatureDate: "",
    seniorCreditController: "",
    creditApprovalStatus: "",
    creditSalesExecutiveRemarks: "",
    creditSalesExecutiveSignatureDate: "",
    financeOfficerName: "",
    financeSignatureDate: "",
    financeSignature: "",
    primaryCustomerCode: "",
    hirerCode: "",
    mainBusinessCode: "",
    creditPeriod: "",
    creditLimitAmount: "",
    preparedBy: "",
    authorizedBy: "",
    glCode: "",
    creditSalesExecutiveSignature: "",
    accountType: "",
  });

  useEffect(() => {
    setFormData({
      ...formData,
      leadId: id,
      salesExecutiveName: lead?.salesRep?.FullName,
    });
  }, [id, lead]);

  const [errors, setErrors] = useState({
    creditSalesExecutiveSignature: "",
    financeSignature: "",
    regionalManagerSignature: "",
    salesManagerSignature: "",
  });
  const handleLogoUpload = (e, type) => {
    console.log(e, type, "h");
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      dispatch(
        UploadImage(file, loginData?.accessToken, (data) => {
          setFormData({ ...formData, [type]: data.data.fileUrl });
        })
      );
    }
  };
  console.log(formData);
  const validateForm = () => {
    let newErrors = {};
    if (!formData.salesExecutiveName) {
      newErrors.salesExecutiveName = "Sales Executive Name is required";
    }
    if (!formData.salesManagerRemarks) {
      newErrors.salesManagerRemarks = "Remarks of Sales Manager is required";
    }
    if (!formData.salesManagerSignatureDate) {
      newErrors.salesManagerSignatureDate =
        "Sales Manager Signature Date is required";
    }
    if (!formData.salesManagerSignature) {
      newErrors.salesManagerSignature = "Sales Manager Signature is required";
    }
    if (!formData.regionalManagerRemarks) {
      newErrors.regionalManagerRemarks =
        "Remarks of Regional Manager is required";
    }
    if (!formData.regionalManagerSignatureDate) {
      newErrors.regionalManagerSignatureDate =
        "Regional Manager Signature Date is required";
    }
    if (!formData.regionalManagerSignature) {
      newErrors.regionalManagerSignature =
        "Regional Manager Signature is required";
    }
    if (!formData.seniorCreditController) {
      newErrors.seniorCreditController = "Sales Executive Name is required";
    }
    if (!formData.creditSalesExecutiveSignatureDate) {
      newErrors.creditSalesExecutiveSignatureDate =
        "Sales Executive Signature Date is required";
    }
    if (!formData.creditSalesExecutiveSignature) {
      newErrors.creditSalesExecutiveSignature =
        "Sales Executive Signature is required";
    }
    if (!formData.creditSalesExecutiveRemarks) {
      newErrors.creditSalesExecutiveRemarks =
        "Remarks of Credit Sales Executive is required";
    }
    if (!formData.financeOfficerName) {
      newErrors.financeOfficerName = "Finance Officer Name is required";
    }
    if (!formData.financeSignatureDate) {
      newErrors.financeSignatureDate = "Finance Signature Date is required";
    }
    if (!formData.financeSignature) {
      newErrors.financeSignature = "Finance Signature is required";
    }
    if (!formData.primaryCustomerCode) {
      newErrors.primaryCustomerCode = "Primary Customer Code is required";
    }
    if (!formData.hirerCode) {
      newErrors.hirerCode = "Hirer Code is required";
    }
    if (!formData.creditPeriod) {
      newErrors.creditPeriod = "Credit Period is required";
    }
    if (!formData.creditLimitAmount) {
      newErrors.creditLimitAmount = "Credit Limit AED is required";
    }
    if (!formData.mainBusinessCode) {
      newErrors.mainBusinessCode = "Main Business Code is required";
    }
    if (!formData.glCode) {
      newErrors.glCode = "GI Code is required";
    }
    if (!formData.preparedBy) {
      newErrors.preparedBy = "Prepared By is required";
    }
    if (!formData.authorizedBy) {
      newErrors.authorizedBy = "Authorized By is required";
    }
    if (!formData.creditApprovalStatus) {
      newErrors.creditApprovalStatus = "Approval Status is required";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const validExtensions = ["jpeg", "jpg", "png"];

  const accountType = [
    { label: "Existing", value: "Existing" },
    { label: "New", value: "New" },
  ];
  const selectedAccountType = accountType?.find(
    (option) => option.value === formData.accountType
  );

  const handleSubmit = () => {
    if (validateForm()) {
      const formattedData = {
        ...formData,
        leadId: id,
        salesManagerSignatureDate: formatDate(
          formData.salesManagerSignatureDate
        ),
        regionalManagerSignatureDate: formatDate(
          formData.regionalManagerSignatureDate
        ),
        creditSalesExecutiveSignatureDate: formatDate(
          formData.creditSalesExecutiveSignatureDate
        ),
        financeSignatureDate: formatDate(formData.financeSignatureDate),
      };
      dispatch(
        addConvertAccount(formattedData, loginData?.accessToken, () => {
          onClose();
          onHit();
        })
      );
    }
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4 w-full">
      <div
        onClick={onClose}
        className="bg-gray-800 opacity-50 fixed inset-0"
      ></div>
      <div className="w-full flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-lg p-4 w-[95%] md:w-[60%] relative">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold">Create Account</h2>
            <button
              onClick={onClose}
              className="top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>

          <div className="h-[60vh] overflow-y-auto p-8">
            <h3 className="font-semibold text-lg mb-4">
              Sales division use only
            </h3>
            <div className="mt-[-21px] w-full mb-4">
              <DropDownCustom
                selectedValue={selectedAccountType}
                handleChanges={(selectedOption) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    ["accountType"]: selectedOption.value,
                  }));
                }}
                options={accountType}
                isSearchable={false}
                label="Account Type"
                placeholder="Select Account Type"
              />
            </div>
            <div>
              {/* Sales Executive Name Input */}
              <div className="w-full mb-4">
                <Input
                  type="text"
                  disabled
                  placeholder="Sales Executive Name"
                  name="salesExecutiveName"
                  value={formData.salesExecutiveName}
                  onChange={handleChange}
                  float={true}
                  label={"Sales Executive Name"}
                  error={errors.salesExecutiveName}
                />
              </div>

              {/* Remarks of Sales Manager */}
              <div className="w-full mb-4">
                <Input
                  type="text"
                  placeholder="Remarks of Sales Manager"
                  name="salesManagerRemarks"
                  value={formData.salesManagerRemarks}
                  onChange={handleChange}
                  float={true}
                  error={errors.salesManagerRemarks}
                />
              </div>

              <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="date"
                    name="salesManagerSignatureDate"
                    value={formData.salesManagerSignatureDate}
                    onChange={handleChange}
                    float={true}
                    label={"Sales Manager Signature Date"}
                    error={errors.salesManagerSignatureDate}
                  />
                </div>
                <div className="w-full">
                  <SignatureUpload
                    error={errors.salesManagerSignature}
                    handleFileChange={handleLogoUpload}
                    type="salesManagerSignature"
                  />
                </div>
              </div>

              {/* Regional Manager Remarks and Signature */}
              <div className="w-full mb-4">
                <Input
                  type="text"
                  placeholder="Remarks of Regional Manager"
                  name="regionalManagerRemarks"
                  value={formData.regionalManagerRemarks}
                  onChange={handleChange}
                  float={true}
                  error={errors.regionalManagerRemarks}
                />
              </div>
              <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="date"
                    name="regionalManagerSignatureDate"
                    value={formData.regionalManagerSignatureDate}
                    onChange={handleChange}
                    float={true}
                    label={"Regional Manager Signature Date"}
                    error={errors.regionalManagerSignatureDate}
                  />
                </div>
                <div className="w-full">
                  <SignatureUpload
                    error={errors.regionalManagerSignature}
                    handleFileChange={handleLogoUpload}
                    type="regionalManagerSignature"
                  />
                  {/* {errors.regionalManagerSignature && (
                    <span>{errors.regionalManagerSignature}</span>
                  )} */}
                </div>
              </div>
            </div>

            <h3 className="font-semibold text-lg mb-4">
              Credit Department use only
            </h3>

            <div className="flex items-center justify-between">
              <h4 className="font-semibold text-md">
                Senior Credit Controller
              </h4>
              <div className="flex space-x-4">
                <AuthButton
                  width={"20%"}
                  title={"Approved"}
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      creditApprovalStatus: "Approved",
                    }))
                  }
                  className={`px-4 py-2 rounded-md ${
                    formData.creditApprovalStatus === "Approved" || ""
                      ? "text-white"
                      : "bg-white border border-gray-300 hover:bg-gray-100"
                  }`}
                />
                <AuthButton
                  width={"20%"}
                  title={"Rejected"}
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      creditApprovalStatus: "Rejected",
                    }))
                  }
                  className={`px-4 py-2 rounded-md ${
                    formData.creditApprovalStatus === "Rejected"
                      ? "text-white"
                      : "bg-white border border-gray-300 hover:bg-gray-100"
                  }`}
                />
              </div>
            </div>

            <div>
              <div className="w-full mb-4">
                <Input
                  type="text"
                  placeholder="Sales Executive Name"
                  name="seniorCreditController"
                  value={formData.seniorCreditController}
                  onChange={handleChange}
                  float={true}
                  error={errors.seniorCreditController}
                />
              </div>
              <div className="w-full mb-4">
                <Input
                  type="text"
                  placeholder="Remarks of Sales Manager"
                  name="creditSalesExecutiveRemarks"
                  value={formData.creditSalesExecutiveRemarks}
                  onChange={handleChange}
                  float={true}
                  error={errors.creditSalesExecutiveRemarks}
                />
              </div>

              {/* Credit Sales Manager Signature Date and Signature */}
              <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="date"
                    name="creditSalesExecutiveSignatureDate"
                    value={formData.creditSalesExecutiveSignatureDate}
                    onChange={handleChange}
                    float={true}
                    label={"Credit Sales Manager Date"}
                    error={errors.creditSalesExecutiveSignatureDate}
                  />
                </div>
                <div className="w-full">
                  <SignatureUpload
                    error={errors.creditSalesExecutiveSignature}
                    handleFileChange={handleLogoUpload}
                    type="creditSalesExecutiveSignature"
                  />
                  {/* {errors.creditSalesExecutiveSignature && (
                    <span>{errors.creditSalesExecutiveSignature}</span>
                  )} */}
                </div>
              </div>

              {/* Credit Regional Manager Remarks and Signature */}
              {/* <div className="w-full mb-4">
                <Input
                  type="text"
                  placeholder="Remarks of Regional Manager"
                  name="creditRegionalManagerRemarks"
                  value={formData.creditRegionalManagerRemarks}
                  onChange={handleChange}
                  float={true}
                  error={errors.creditRegionalManagerRemarks}
                />
              </div> */}
              {/* <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="date"
                    name="creditRegionalManagerSignatureDate"
                    value={formData.creditRegionalManagerSignatureDate}
                    onChange={handleChange}
                    float={true}
                    label={"Credit Regional Manager Signature Date"}
                    error={errors.creditRegionalManagerSignatureDate}
                  />
                </div>
                <div className="w-full">
                  <Input
                    type="text"
                    placeholder="Signature"
                    name="creditRegionalManagerSignature"
                    value={formData.creditRegionalManagerSignature}
                    onChange={handleChange}
                    float={true}
                    error={errors.creditRegionalManagerSignature}
                  />
                </div>
              </div> */}
            </div>

            <h3 className="font-semibold text-lg mb-4">
              Finance Division use only
            </h3>
            <div>
              {/* Finance Officer Name */}
              <div className="w-full mb-4">
                <Input
                  type="text"
                  placeholder="Name"
                  name="financeOfficerName"
                  value={formData.financeOfficerName}
                  onChange={handleChange}
                  float={true}
                  error={errors.financeOfficerName}
                />
              </div>

              {/* Finance Signature Date and Signature */}
              <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="date"
                    name="financeSignatureDate"
                    value={formData.financeSignatureDate}
                    onChange={handleChange}
                    float={true}
                    label={"Finance Signature Date"}
                    error={errors.financeSignatureDate}
                  />
                </div>
                <div className="w-full">
                  <SignatureUpload
                    error={errors.financeSignature}
                    handleFileChange={handleLogoUpload}
                    type="financeSignature"
                  />
                  {/* {errors.financeSignature && (
                    <span>{errors.financeSignature}</span>
                  )} */}
                </div>
              </div>
              <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="text"
                    placeholder="Primary Customer Code"
                    name="primaryCustomerCode"
                    value={formData.primaryCustomerCode}
                    onChange={handleChange}
                    float={true}
                    error={errors.primaryCustomerCode}
                  />
                </div>
                <div className="w-full">
                  <Input
                    type="text"
                    placeholder="Hirer Code"
                    name="hirerCode"
                    value={formData.hirerCode}
                    onChange={handleChange}
                    float={true}
                    error={errors.hirerCode}
                  />
                </div>
              </div>

              {/* Credit Period and Credit Limit AED */}
              <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="text"
                    placeholder="Credit Period"
                    name="creditPeriod"
                    value={formData.creditPeriod}
                    onChange={handleChange}
                    float={true}
                    error={errors.creditPeriod}
                    label={"Credit Period"}
                  />
                </div>
                <div className="w-full">
                  <Input
                    type="text"
                    placeholder="Credit Limit AED"
                    name="creditLimitAmount"
                    value={formData.creditLimitAmount}
                    onChange={handleChange}
                    float={true}
                    error={errors.creditLimitAmount}
                  />
                </div>
              </div>

              {/* Main Account Code and GI Code */}
              <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="text"
                    placeholder="Main Account Code"
                    name="mainBusinessCode"
                    value={formData.mainBusinessCode}
                    onChange={handleChange}
                    float={true}
                    error={errors.mainBusinessCode}
                  />
                </div>
                <div className="w-full">
                  <Input
                    type="text"
                    placeholder="GI Code"
                    name="glCode"
                    value={formData.glCode}
                    onChange={handleChange}
                    float={true}
                    error={errors.glCode}
                  />
                </div>
              </div>

              {/* Prepared By and Authorized By */}
              <div className="w-full flex flex-row mb-4">
                <div className="w-full pr-[20px]">
                  <Input
                    type="text"
                    placeholder="Prepared By"
                    name="preparedBy"
                    value={formData.preparedBy}
                    onChange={handleChange}
                    float={true}
                    error={errors.preparedBy}
                  />
                </div>
                <div className="w-full">
                  <Input
                    type="text"
                    placeholder="Authorized By"
                    name="authorizedBy"
                    value={formData.authorizedBy}
                    onChange={handleChange}
                    float={true}
                    error={errors.authorizedBy}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end mt-6 space-x-4">
            <AuthButton
              className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
              width={"20%"}
              title={"Cancel"}
              onClick={onClose}
            />
            <AuthButton
              width={"20%"}
              title={"Save"}
              className="px-4 py-2 text-white rounded-md"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default CreateAccountModal;
